<template>
<!--  {
  "id": 6292279,
  "weiyi": "gt_175289449494",
  "number": "gt_1752894494940000827",
  "pindex_id": 89,
  "house_id": 1461519,
  "h_name_date": "顺德太平洋鼎旺商业中心项目->外协单位->B3->3栋天天一泉",
  "charge_id": 235,
  "charge_name": "公共分摊电费",
  "charge": "40.19",
  "chargePay": "40.19",
  "PaidChargeSum": "0.00",
  "state": 1,
  "generate_date": 1752894477,
  "xsc_ChargeItemID_id": 34,
  "startDate": "2025-06-01",
  "endDate": "2025-06-30",
  "xsc_Price": "0.6960",
  "xsc_Amount": "57.7500",
  "discount": null,
  "delaySum": null,
  "delayDiscount": null,
  "remark": null,
  "IsFrozen": 0,
  "xsc_LastReadDegree": "2706.0000",
  "xsc_CurrentReadDegree": "2761.0000",
  "should_charge_date": "2025-06-30",
  "customer_id": 97600,
  "meter_id": 196907,
  "frozen_type": 0,
  "energy": 2,
  "task_id": 742982,
  "order_table": null,
  "order_id": null,
  "is_examine": 2,
  "batch_number": "175289758892",
  "is_lock": 1,
  "object_ids": "286047479",
  "update_time": 1752918779,
  "project_name": "顺德太平洋鼎旺商业中心项目",
  "customer_name": "3栋天天一泉",
  "charge_item_name": "公共分摊电费"
}-->
  <div>
    <el-dialog
      title="能耗账单拆分"
      :visible.sync="visible"
      width="1200px"
      :before-close="handleClose"
    >
      <div>
        <div>
          <el-descriptions :column="2" border :label-style="{width:'100px'}" :content-style="{width:'calc( 30% - 120px )'}">
            <el-descriptions-item label="ID">{{ oldData.id }}</el-descriptions-item>
            <!--          <el-descriptions-item label="唯一标识">{{ oldData.weiyi }}</el-descriptions-item>-->
            <!--          <el-descriptions-item label="订单编号">{{ oldData.number }}</el-descriptions-item>-->
            <!--          <el-descriptions-item label="项目">{{ oldData.project_name }}</el-descriptions-item>-->
            <el-descriptions-item label="房间">{{ oldData.h_name_date }}</el-descriptions-item>
            <el-descriptions-item label="业主">{{ oldData.customer_name }}</el-descriptions-item>
            <el-descriptions-item label="收费项目">{{ oldData.charge_name }}</el-descriptions-item>
            <el-descriptions-item label="收费标准">{{ oldData.charge_item_name }}</el-descriptions-item>
            <el-descriptions-item label="计费周期">{{ oldData.startDate }} ~ {{ oldData.endDate }}</el-descriptions-item>
            <el-descriptions-item label="单价">{{ oldData.xsc_Price }}</el-descriptions-item>
            <el-descriptions-item label="数量/度量">{{ oldData.xsc_Amount }}</el-descriptions-item>
            <el-descriptions-item label="上期读数">{{ oldData.xsc_LastReadDegree }}</el-descriptions-item>
            <el-descriptions-item label="本期读数">{{ oldData.xsc_CurrentReadDegree }}</el-descriptions-item>
            <el-descriptions-item label="应收金额">{{ oldData.charge }}</el-descriptions-item>
            <el-descriptions-item label="实收金额">{{ oldData.chargePay }}</el-descriptions-item>
            <el-descriptions-item label="状态">{{ oldData.state }}</el-descriptions-item>
            <el-descriptions-item label="应收日期">{{ oldData.should_charge_date }}</el-descriptions-item>
            <!--          <el-descriptions-item label="生成日期">{{ oldData.generate_date }}</el-descriptions-item>-->
            <!--          <el-descriptions-item label="更新时间">{{ oldData.update_time }}</el-descriptions-item>-->
          </el-descriptions>
        </div>
        <div>
          <div style="display:flex;justify-content:flex-start;margin:5px 0;">
            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="split_date" placeholder="选择日期" @change="computeSplit()"></el-date-picker>
            <!--          <el-button type="primary" size="mini" @click="computeSplit">拆单</el-button>-->
            <!--          <el-button @click="addOrder">增加拆分</el-button>-->
            <span style="margin-left: 10px;color: #ff3d00;">选择时间，系统自动拆分，如需特殊调整，请填写以下可填写处。</span>
          </div>
          <el-table border :data="splitData" width="99%" height="300px">
            <!--          <el-table-column type="selection" width="55" fixed></el-table-column>-->
            <!--        <el-table-column prop="id" label="id" width="80"></el-table-column>-->
            <el-table-column prop="h_name_date" label="房产" width="320" align="center" fixed></el-table-column>
            <el-table-column prop="customer_name" label="客户" width="180" align="center">
              <template slot-scope="scope">
                <el-link type="primary" @click="selectUser(scope.row)">{{scope.row.customer_name}}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="charge_sum" label="周期" width="180" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.startDate}}~{{scope.row.endDate}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="chargePay" label="应收费用" width="100" align="center">
              <template slot-scope="scope">
                <!--              <el-input v-model="scope.row.chargePay" style="width:100px" @input="computeCharge('chargePay')"/>-->
                {{scope.row.chargePay}}
              </template>
            </el-table-column>
            <el-table-column prop="charge" label="收费金额" width="100" align="center">
              <template slot-scope="scope">
                <!--              <el-input v-model="scope.row.charge" style="width:100px" @input="computeCharge('charge')"/>-->
                {{scope.row.charge}}
              </template>
            </el-table-column>
            <el-table-column prop="should_charge_date" label="应收日期" width="100" align="center">
              <template slot-scope="scope">
                {{scope.row.should_charge_date}}
              </template>
            </el-table-column>
            <el-table-column prop="xsc_LastReadDegree" label="上期读数" width="100" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.xsc_LastReadDegree" placeholder="上期读数" />
              </template>
            </el-table-column>
            <el-table-column prop="xsc_CurrentReadDegree" label="本期读数" width="100" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.xsc_CurrentReadDegree" placeholder="本期读数" />
              </template>
            </el-table-column>
            <el-table-column prop="charge_item_name" label="收费项目" width="120" align="center"></el-table-column>
            <el-table-column prop="charge_name" label="收费标准" width="200" align="center"></el-table-column>
            <el-table-column prop="xsc_Price" label="单价" width="100" align="center">
              <template slot-scope="scope">
                <!--              <el-input v-model="scope.row.xsc_Price" placeholder="数量/用量" />-->
                {{scope.row.xsc_Price}}
              </template>
            </el-table-column>
            <el-table-column prop="xsc_Amount" label="数量/用量" width="100" align="center">
              <template slot-scope="scope">
                <!--              <el-input v-model="scope.row.xsc_Amount" placeholder="数量/用量" />-->
                {{scope.row.xsc_Amount}}
              </template>
            </el-table-column>
            <el-table-column prop="is_lock" label="锁定状态" width="100" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.is_lock===1">已锁定</span>
                <span v-else>未锁定</span>
              </template>
            </el-table-column>
            <el-table-column prop="is_examine" label="审批状态" width="100" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.is_examine===1">审核中</span>
                <span v-else-if="scope.row.is_examine===2">已审核</span>
                <span v-else-if="scope.row.is_examine===-1">已驳回</span>
                <span v-else>待审核</span>
              </template>
            </el-table-column>

            <el-table-column label="操作 " fixed="right" width="120" align="center">
              <template slot-scope="scope">
                <!--              <el-button type="danger" size="mini" @click="delOrder(scope.$index)">删除</el-button>-->
              </template>
            </el-table-column>
          </el-table>

        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="visible=false">关 闭</el-button>
        <el-button type="primary" size="mini" @click="submitSplit">拆 单</el-button>
      </div>
    </el-dialog>
    <ErpRoomUser ref="erpRoomUserRef" />
  </div>
</template>

<script>
import moment from "moment";
import MeterHttp from "../../../common/MeterHttp";
import ErpRoomUser from "../../../../Common/ErpRoomUser";
export default {
  name: "MeterOrderUserSplit",
  components: {ErpRoomUser},
  data(){
    return {
      visible: false,
      oldData: {
        id: 6292279,
        weiyi: "gt_175289449494",
        number: "gt_1752894494940000827",
        pindex_id: 89,
        house_id: 1461519,
        h_name_date: "顺德太平洋鼎旺商业中心项目->外协单位->B3->3栋天天一泉",
        charge_id: 235,
        charge_name: "公共分摊电费",
        charge: "40.19",
        chargePay: "40.19",
        PaidChargeSum: "0.00",
        state: 1,
        generate_date: 1752894477,
        xsc_ChargeItemID_id: 34,
        startDate: "2025-06-01",
        endDate: "2025-06-30",
        xsc_Price: "0.6960",
        xsc_Amount: "57.7500",
        discount: null,
        delaySum: null,
        delayDiscount: null,
        remark: null,
        IsFrozen: 0,
        xsc_LastReadDegree: "2706.0000",
        xsc_CurrentReadDegree: "2761.0000",
        should_charge_date: "2025-06-30",
        customer_id: 97600,
        meter_id: 196907,
        frozen_type: 0,
        energy: 2,
        task_id: 742982,
        order_table: null,
        order_id: null,
        is_examine: 2,
        batch_number: "175289758892",
        is_lock: 1,
        object_ids: "286047479",
        update_time: 1752918779,
        project_name: "顺德太平洋鼎旺商业中心项目",
        customer_name: "3栋天天一泉",
        charge_item_name: "公共分摊电费"
      },
      splitData:[],
      __CALL_BACK__:null,
      split_date:moment().endOf("day").format("YYYY-MM-DD")
    }
  },
  methods: {
    show(item,callback){
      const that=this;
      that.oldData=item;
      that.visible=true;
      that.split_date=that.oldData.endDate;
      that.__CALL_BACK__=callback;
    },
    handleClose() {
      this.visible = false;
      this.__CALL_BACK__=undefined;
    },
    addOrder(){
      const that=this;
      that.splitData.push({
        ...that.oldData,
        id:0,
      })
      that.computeCharge("chargePay");
      that.computeCharge("charge");
    },
    delOrder(index){
      const that=this;
      that.splitData.splice(index,1);
      that.computeCharge("chargePay");
      that.computeCharge("charge");
    },
    computeCharge(name){
      const that=this;
      let count=that.splitData.length;
      if(count===0){
        return;
      }
      let sum_money=that.oldData[name];
      let money=0;
      that.splitData.map((item,index)=>{
        if(index===count-1){
          that.splitData[count-1][name]=Math.round((sum_money-money)*100)/100;
        }else {
          money=Math.round((money+parseFloat(item[name]))*100)/100;
        }
      });
    },
    computeSplit() {
      const that = this;
      let start = moment(that.oldData.startDate);
      let end = moment(that.oldData.endDate);
      let split = moment(that.split_date);

      // 验证日期有效性
      if (!start.isValid() || !end.isValid() || !split.isValid()) {
        console.error('无效的日期格式');
        that.$message.error('无效的日期格式');
        return;
      }

      // 确保开始日期在结束日期之前
      if (start.isAfter(end)) {
        [start, end] = [end, start]; // 交换日期
      }

      // 计算总天数（包含首尾两天）
      const day_num = end.diff(start, 'days') + 1;

      // 检查分割日期是否在有效范围内
      if (split.isBefore(start) || split.isAfter(end)) {
        console.warn('分割日期不在开始日期和结束日期之间');
        that.$message.warning('分割日期不在开始日期和结束日期之间');
        return;

      }

      // 计算各段天数（包含首尾两天）
      const start_date = split.diff(start, 'days') + 1;
      const end_date = end.diff(split, 'days')+1;

      // console.log('开始日期:', start.format('YYYY-MM-DD'));
      // console.log('结束日期:', end.format('YYYY-MM-DD'));
      // console.log('总天数:', day_num); // 现在会显示30天
      // console.log('开始到分割天数:', start_date);
      // console.log('分割到结束天数:', end_date);

      let sum_charge=that.oldData.charge;
      let sum_chargePay=that.oldData.chargePay;
      let start_charge=Math.round(sum_charge/day_num*start_date*100)/100;
      let start_chargePay=Math.round(sum_chargePay/day_num*start_date*100)/100;
      let end_charge=Math.round((sum_charge-start_charge)*100)/100;
      let end_chargePay=Math.round((sum_chargePay-start_chargePay)*100)/100;
      let start_xsc_Amount=Math.round(that.oldData.xsc_Amount/day_num*start_date*100)/100;
      let end_xsc_Amount=Math.round((that.oldData.xsc_Amount-start_xsc_Amount)*100)/100;

      that.splitData=[];
      that.splitData.push({
        ...that.oldData,
        id: 0,
        charge: start_charge,
        chargePay: start_chargePay,
        xsc_Amount: start_xsc_Amount,
        startDate: start.format('YYYY-MM-DD'),
        endDate: split.format('YYYY-MM-DD'),
        is_examine:1,
        is_lock:0,
        number:that.oldData.number+""+Math.round(Math.random()*100),
      });
      if(split.format('YYYY-MM-DD')!==end.format('YYYY-MM-DD')){
        that.splitData.push({
          ...that.oldData,
          id: 0,
          charge: end_charge,
          chargePay: end_chargePay,
          xsc_Amount: end_xsc_Amount,
          startDate: split.add(1,'days').format('YYYY-MM-DD'),
          endDate: end.format('YYYY-MM-DD'),
          is_examine:1,
          is_lock:0,
          number:that.oldData.number+""+Math.round(Math.random()*100),
        });
      }
    },
    submitSplit() {
      const that = this;
      let data = that.splitData;
      if (data.length === 0) {
        that.$message.warning('请先拆单');
        return;
      }
      MeterHttp.post("MeterOrderHouse/orderSplit",{
        project_id:that.oldData.pindex_id,
        old_data:JSON.stringify(that.oldData),
        split_data:JSON.stringify(data),
        user_type:(that.$route.query.type||0),
      }, res => {
        if (res.code) {
          that.$message.success(res.msg);
          that.__CALL_BACK__()
          that.visible = false;
        }else {
          that.$message.error(res.msg||'拆单失败');
        }
      })
    },
    selectUser(item){
      const that=this;
      that.$refs.erpRoomUserRef.show(data=>{
        item.customer_id=data.id;
        item.customer_name=data.name;
      },"")
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
  padding: 10px 16px;
  border-top: 1px solid #e8e8e8;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/MeterOrderUserSplit.vue